import React, { useEffect, useState } from 'react';
import { array, bool, func, object } from 'prop-types';
import { withRouter } from 'react-router';

import { connect, useDispatch } from 'react-redux';

import { isEmpty } from 'lodash';

import queryString from 'query-string';

import Button from '@material-ui/core/Button';

import NavSelect from './NavSelect';
import {enqueueSnackbar} from '../actions/applicationMessageActions';

import * as AttributeManagementActions from '../actions/attributeManagementActions';
import * as BobActions from '../actions/bobActions';
import * as DashboardActions from '../actions/dashboardActions';
import * as CompanyInfoActions from '../actions/companyInfoActions';
import * as CompanyManagementActions from '../actions/companyManagementActions';
import * as ConfigurationActions from '../actions/configurationActions';
import * as CoreActions from '../actions/coreActions';
import * as CurrentUserActions from '../actions/currentUserActions';


import { headerContent } from '../localization/en-us/headerContent';

import classes from './BobNavSelectors.module.css';

const BobNavSelectors = ({
    activeNavCompany,
    activeNavClient,
    activeNavSite,
    activeNavEquipment,
    allRoles,
    clearDashboardData,
    clearDashboardClientData,
    clearDashboardSiteData,
    companies,
    companyInfo,
    cancelSelectedNavOption,
    currentUser,
    fetchAllConfigurations,
    fetchAllScopes,
    fetchApplications,
    fetchAttributes,
    fetchCompanyInfo,
    fetchCurrentUserRole,
    fetchEnergyPrintIntegrations,
    fetchNavClients,
    fetchNavEquipment,
    fetchNavSites,
    isFromHeader,
    history,
    navClients,
    navClientsMeta,
    navEquipment,
    navEquipmentMeta,
    navSites,
    navSitesMeta,
    resetNavOptions,
    setActiveNavClient,
    setActiveNavCompany,
    setActiveNavEquipment,
    setActiveNavSite,
    setAllRoles,
    setCurrentScopes,
    setFaultHistory,
    setFaultSummary,
    setNavClient,
    setNavCompany,
    setNavEquipment,
    setNavSite,
    setSelectedRuleSensors,
    setSelectedSensors,
    targetNavClient,
    targetNavCompany,
    targetNavEquipment,
    targetNavSite,
    ...props
}) => {
    const [companyList, setCompanyList] = useState([]);
    const [isDisabled, setIsDisabled] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        if (companyInfo.companyId) {
            fetchNavClients(companyInfo.companyId);
        }
    }, [companyInfo.companyId]);

    useEffect(() => {
        if (companies.length) {
            const collection = companies.map(company => company.company).sort((a, b) => sorter(a, b));

            setCompanyList(collection);

            if (targetNavCompany.name) {
                setIsDisabled(false);
            }
        }
    }, [companies, targetNavCompany]);

    useEffect(() => {
        if (isEmpty(activeNavClient) && !isEmpty(targetNavClient)) {
            setActiveNavClient({...targetNavClient});
        }
    }, [targetNavClient, activeNavClient]);

    useEffect(() => {
        if (isEmpty(activeNavSite) && !isEmpty(targetNavSite)) {
            setActiveNavSite({...targetNavSite});
        }
    }, [targetNavSite, activeNavSite]);

    useEffect(() => {
        if (isEmpty(activeNavEquipment) && !isEmpty(targetNavEquipment)) {
            setActiveNavEquipment({...targetNavEquipment});
        }
    }, [targetNavEquipment, activeNavEquipment]);

    const sorter = (a, b) => {
        let itemA = a.name.toUpperCase();
        let itemB = b.name.toUpperCase();

        if (itemA < itemB) {
            return -1;
        }
        if (itemA > itemB) {
            return 1;
        }

        return 0;
    };

    const handleCompanyChange = async () =>
    {
        const currentCompany = companies.find( c => c.company.id === targetNavCompany.id );
        if ( currentCompany )
        {
            await fetchCompanyInfo( currentCompany );
            setActiveNavCompany({ ...targetNavCompany });
            const promises = [
                fetchAttributes(),
                fetchAllConfigurations(currentUser.id)
            ];
            await Promise.all(promises.map(p => p));
        }
    };

    const handleGo = async () => {
        let path = '/v2/dashboard/company';
        let queryValuesString = '';
        const UrlqueryValues = queryString.parse(history.location.search);
        const pathName = history.location.pathname;
        const companyChanged = activeNavCompany.id !== targetNavCompany.id;

        const queryValues = {
            company: targetNavCompany.id
        };

        
        if (companyChanged) {
            queryValues.appId = UrlqueryValues.appId ? UrlqueryValues.appId : 'ad356bf2-b9db-4bb5-922e-c3394b1a63e3';
            queryValues.parentId = UrlqueryValues.parentId ? UrlqueryValues.parentId : 'ad356bf2-b9db-4bb5-922e-c3394b1a63e4';
            queryValues.childId = UrlqueryValues.childId ? UrlqueryValues.childId : 'ccb00d85-7b0c-44ba-bd0e-db216ef1ee46';
    
            queryValuesString = queryString.stringify(queryValues);
            history.push(`${path}?${queryValuesString}`);
            
            setActiveNavCompany({ ...targetNavCompany });
            setActiveNavClient({});
            setActiveNavSite({});
            setActiveNavEquipment({});

            resetNavOptions();
            sessionStorage.setItem('companyId', targetNavCompany.id);
            await handleCompanyChange();
        }

        

        // k2acore page
        if (UrlqueryValues.appId === '1710345b-cf28-4a02-9bf4-df9209ff29cb') { 
            path = '/v2/dashboard/core/entities';

            queryValues.appId = '1710345b-cf28-4a02-9bf4-df9209ff29cb';

            // K2A Core - Company - Client
            queryValues.parentId = '7e71f5d4-9fbf-4710-8601-e1f11e681479';
            queryValues.childId = '231b3d07-1afb-42a0-b6ff-ecb9c4dd8c48';

            setActiveNavCompany({ ...targetNavCompany });
            setActiveNavClient({});
            setActiveNavSite({});
            setActiveNavEquipment({});

            if (!isEmpty(targetNavEquipment)) {
                if (targetNavEquipment !== activeNavEquipment) {
                    setSelectedSensors([]);
                }

                // K2A Core - Company - Equipment
                queryValues.parentId = '7e71f5d4-9fbf-4710-8601-e1f11e681479';
                queryValues.childId = '0da7cfdd-f757-4231-8979-7ff2b806e0a5';

                queryValues.equipment = targetNavEquipment.id;
                queryValues.site = targetNavSite.id;
                queryValues.client = targetNavClient.id;

                setActiveNavEquipment({...targetNavEquipment});
                setActiveNavSite({...targetNavSite});
                setActiveNavClient({...targetNavClient});
            } else if (!isEmpty(targetNavSite)) {
                queryValues.site = targetNavSite.id;
                queryValues.client = targetNavClient.id;

                // K2A Core - Site - Equipment
                queryValues.parentId = '33ba6af0-1e7a-4fcf-b75b-f355a01a962b';
                queryValues.childId = '7035ee2f-b8ee-48ee-a9ac-ac522917dcdd';

                setActiveNavSite({...targetNavSite});
                setActiveNavClient({...targetNavClient});
            } else if (!isEmpty(targetNavClient)) {
                // K2A Core - Client - Site
                queryValues.parentId = '3ee59a8f-d13a-475b-b424-ee55eef98a65';
                queryValues.childId = 'e979b520-3695-422d-a914-ba55c51fb316';

                queryValues.client = targetNavClient.id;
                setActiveNavClient({...targetNavClient});
            }
        //Navigating to Bob from Energy when site or equipment selected
        } else if (UrlqueryValues.appId === 'ad356bf2-b9db-4bb5-922e-c3394b1a63e3' || (UrlqueryValues.appId === 'c2d1468e-7e4b-4e98-95d1-72af77bf843e' && targetNavSite.id) || pathName.includes('/v2/dashboard/rules')) { // bob
        // company overview page
            queryValues.appId = 'ad356bf2-b9db-4bb5-922e-c3394b1a63e3';
            queryValues.parentId = 'ad356bf2-b9db-4bb5-922e-c3394b1a63e4';
            queryValues.childId = 'ccb00d85-7b0c-44ba-bd0e-db216ef1ee46';

            if (targetNavCompany.id !== activeNavCompany.id) {
                setSelectedSensors([]);
                setSelectedRuleSensors([]);
                setFaultSummary([], {});
                setFaultHistory([], {});
                await clearDashboardData();
            } else if (targetNavClient.id !== activeNavClient.id) {
                setSelectedSensors([]);
                setSelectedRuleSensors([]);
                await clearDashboardClientData();
            } else if (targetNavSite.id !== activeNavSite.id) {
                setSelectedSensors([]);
                setSelectedRuleSensors([]);
                await clearDashboardSiteData();
            }

            setActiveNavCompany({...targetNavCompany});
            setActiveNavClient({});
            setActiveNavSite({});
            setActiveNavEquipment({});

            if (!isEmpty(targetNavEquipment)) {
                if (targetNavEquipment !== activeNavEquipment) {
                    setSelectedSensors([]);
                }
                queryValues.equipment = targetNavEquipment.id;
                queryValues.site = targetNavSite.id;
                queryValues.client = targetNavClient.id;

                // equipment overview page
                queryValues.appId = 'ad356bf2-b9db-4bb5-922e-c3394b1a63e3';
                queryValues.parentId = '7a88bd3d-64e3-4af9-aa06-9a31533df83c';
                queryValues.childId = 'c49ee7a9-6a28-4820-967c-6c6a9652a4c8';

                path = '/v2/dashboard/equipment';

                setActiveNavEquipment({...targetNavEquipment});
                setActiveNavSite({...targetNavSite});
                setActiveNavClient({...targetNavClient});
            } else if (!isEmpty(targetNavSite)) {
                queryValues.site = targetNavSite.id;
                queryValues.client = targetNavClient.id;

                // site overview page
                queryValues.appId = 'ad356bf2-b9db-4bb5-922e-c3394b1a63e3';
                queryValues.parentId = 'c0c505f5-c7fc-4317-8cb6-f6e631142a77';
                queryValues.childId = 'bb5be75b-d466-48d5-99da-79cd66504f20';

                path = '/v2/dashboard/site';

                setActiveNavSite({...targetNavSite});
                setActiveNavClient({...targetNavClient});
            } else if (!isEmpty(targetNavClient)) {
                queryValues.client = targetNavClient.id;

                // client overview page
                queryValues.appId = 'ad356bf2-b9db-4bb5-922e-c3394b1a63e3';
                queryValues.parentId = 'a73c8c70-35aa-48b7-a797-4c607ae25280';
                queryValues.childId = 'f6ba2344-ba47-42c5-a98b-978365ca3936';

                path = '/v2/dashboard/client';

                setActiveNavClient({...targetNavClient});
            }
        //Energy
        } else if (UrlqueryValues.appId === '46d93819-f375-4d5c-b117-bb374c032862' && targetNavClient.id) {
            path = '/v2/dashboard/energy';

            queryValues.appId = '46d93819-f375-4d5c-b117-bb374c032862';

            setActiveNavCompany({ ...targetNavCompany });
            setActiveNavClient({});
            setActiveNavSite({});
            setActiveNavEquipment({});

            if (!isEmpty(targetNavEquipment)) {
                // K2A Core - Company - Equipment
                queryValues.parentId = '16cc471d-a182-421d-bb2a-eb9560939c53';
                queryValues.childId = '4ae23613-301a-4644-b2fa-e9b3ce881e0f';

                queryValues.equipment = targetNavEquipment.id;
                queryValues.site = targetNavSite.id;
                queryValues.client = targetNavClient.id;

                setActiveNavEquipment({ ...targetNavEquipment });
                setActiveNavSite({ ...targetNavSite });
                setActiveNavClient({ ...targetNavClient });
            } else if (!isEmpty(targetNavSite)) {
                queryValues.site = targetNavSite.id;
                queryValues.client = targetNavClient.id;

                // K2A Core - Site - Equipment
                queryValues.parentId = 'bac0591c-03e4-4929-b71d-2f3e3d3e4719';
                queryValues.childId = '64641985-3b11-401a-b990-024d65858582';

                setActiveNavSite({ ...targetNavSite });
                setActiveNavClient({ ...targetNavClient });
            } else if (!isEmpty(targetNavClient)) {
                // K2A Core - Client - Site
                queryValues.parentId = '219ac5b7-d588-425d-a2ca-d2f0d92586ab';
                queryValues.childId = 'd3a45bdb-b5e7-48bf-adb3-5a469c629f20';

                queryValues.client = targetNavClient.id;
                setActiveNavClient({ ...targetNavClient });
            }

        } else {
            if (!isEmpty(targetNavEquipment)) {
                queryValues.childId = 'c49ee7a9-6a28-4820-967c-6c6a9652a4c8';
                queryValues.parentId = '7a88bd3d-64e3-4af9-aa06-9a31533df83c';
                queryValues.appId = 'ad356bf2-b9db-4bb5-922e-c3394b1a63e3';
                queryValues.site = targetNavSite.id;
                queryValues.client = targetNavClient.id;
                queryValues.equipment = targetNavEquipment.id;
                path = '/v2/dashboard/equipment';
            } else if (!isEmpty(targetNavSite)) {
                queryValues.childId = 'bb5be75b-d466-48d5-99da-79cd66504f20';
                queryValues.parentId = 'c0c505f5-c7fc-4317-8cb6-f6e631142a77';
                queryValues.appId = 'ad356bf2-b9db-4bb5-922e-c3394b1a63e3';
                queryValues.client = targetNavClient.id;
                queryValues.site = targetNavSite.id;
                path = '/v2/dashboard/site';
            } else if (!isEmpty(targetNavClient)) {
                queryValues.childId = 'f6ba2344-ba47-42c5-a98b-978365ca3936';
                queryValues.parentId = 'a73c8c70-35aa-48b7-a797-4c607ae25280';
                queryValues.appId = 'ad356bf2-b9db-4bb5-922e-c3394b1a63e3';
                queryValues.client = targetNavClient.id;
                path = '/v2/dashboard/client';
            }

            setActiveNavCompany({ ...targetNavCompany });
            setActiveNavClient({ ...targetNavClient });
            setActiveNavSite({ ...targetNavSite });
            setActiveNavEquipment({ ...targetNavEquipment });
        }

        queryValuesString = queryString.stringify(queryValues);
        history.push(`${path}?${queryValuesString}`);
        
        if (companyChanged)
        {
            dispatch(enqueueSnackbar('Company changed sucessfully', 'success'));
        }
    };

    const isActive = () => {
        const queryValues = queryString.parse(history.location.search);

        if (activeNavCompany.id && (targetNavCompany.id !== queryValues.company || targetNavClient.id !== queryValues.client || targetNavSite.id !== queryValues.site || targetNavEquipment.id !== queryValues.equipment)) {
            return true;
        }

        return false;
    };

    return (
        <div className={classes.BobNavSelectors}>
            <NavSelect
                fetchChildren={fetchNavClients}
                isFromHeader={isFromHeader}
                isCompany={true}
                reset={() => resetNavOptions('company')}
                results={companyList}
                setTarget={setNavCompany}
                targetId={targetNavCompany.id}
                targetName={targetNavCompany.name}
                title={headerContent.company}
            />
            <NavSelect
                cancel={() => cancelSelectedNavOption('client')}
                fetchChildren={fetchNavSites}
                isFromHeader={isFromHeader}
                meta={navClientsMeta}
                parentId={targetNavCompany.id}
                reset={() => resetNavOptions('client')}
                results={navClients}
                search={fetchNavClients}
                setTarget={setNavClient}
                targetId={targetNavClient.id ? targetNavClient.id : ''}
                targetName={targetNavClient.name ? targetNavClient.name : ''}
                title={headerContent.client}
            />
            <NavSelect
                cancel={() => cancelSelectedNavOption('site')}
                fetchChildren={fetchNavEquipment}
                isFromHeader={isFromHeader}
                meta={navSitesMeta}
                parentId={targetNavClient.id}
                reset={() => resetNavOptions('site')}
                results={navSites}
                search={fetchNavSites}
                setTarget={setNavSite}
                targetId={targetNavSite.id ? targetNavSite.id : ''}
                targetName={targetNavSite.name ? targetNavSite.name : ''}
                title={headerContent.site}
            />
            <NavSelect
                cancel={() => cancelSelectedNavOption('equipment')}
                isEquipment={true}
                isFromHeader={isFromHeader}
                meta={navEquipmentMeta}
                parentId={targetNavSite.id}
                results={navEquipment}
                search={fetchNavEquipment}
                setTarget={setNavEquipment}
                targetId={targetNavEquipment.id ? targetNavEquipment.id : ''}
                targetName={targetNavEquipment.name ? targetNavEquipment.name : ''}
                title={headerContent.equipment}
            />
            <Button
                disabled={isDisabled}
                classes={{
                    root:     isActive() ? classes.ActiveBobGoButton : classes.BobGoButton,
                    disabled: classes.disabled
                }}
                onClick={handleGo}
            >
                Go
            </Button>
        </div>
    );
};

BobNavSelectors.defaultProps = {
    activeNavCompany:   {},
    activeNavClient:    {},
    activeNavSite:      {},
    activeNavEquipment: {},
    companies:          [],
    companyInfo:        {},
    fetchNavClients:    () => {},
    fetchNavSites:      () => {},
    fetchNavEquipment:  () => {},
    isFromHeader:       false,
    navClients:         [],
    navClientsMeta:     {},
    navEquipment:       [],
    navEquipmentMeta:   {},
    navSites:           [],
    navSitesMeta:       {},
    resetNavOptions:    () => {},
    setNavClient:       () => {},
    setNavCompany:      () => {},
    setNavEquipment:    () => {},
    setNavSite:         () => {},
    targetNavClient:    {},
    targetNavCompany:   {},
    targetNavEquipment: {},
    targetNavSite:      {}
};

BobNavSelectors.propTypes = {
    activeNavCompany:   object,
    activeNavClient:    object,
    activeNavSite:      object,
    activeNavEquipment: object,
    companies:          array,
    companyInfo:        object,
    isFromHeader:       bool,
    fetchNavClients:    func,
    fetchNavSites:      func,
    fetchNavEquipment:  func,
    navClients:         array,
    navClientsMeta:     object,
    navEquipment:       array,
    navEquipmentMeta:   object,
    navSites:           array,
    navSitesMeta:       object,
    resetNavOptions:    func,
    setNavClient:       func,
    setNavCompany:      func,
    setNavEquipment:    func,
    setNavSite:         func,
    targetNavClient:    object,
    targetNavCompany:   object,
    targetNavEquipment: object,
    targetNavSite:      object
};

const mapStateToProps = state => {
    return {
        activeNavCompany:   state.bob.activeNavCompany,
        activeNavClient:    state.bob.activeNavClient,
        activeNavSite:      state.bob.activeNavSite,
        activeNavEquipment: state.bob.activeNavEquipment,
        allRoles:           state.core.allRoles,
        companies:          state.core.companies,
        companyInfo:        state.companyInfo,
        currentUser:        state.currentUser,
        navClients:         state.bob.navClients,
        navClientsMeta:     state.bob.navClientsMeta,
        navEquipment:       state.bob.navEquipment,
        navEquipmentMeta:   state.bob.navEquipmentMeta,
        navSites:           state.bob.navSites,
        navSitesMeta:       state.bob.navSitesMeta,
        targetNavClient:    state.bob.targetNavClient,
        targetNavCompany:   state.bob.targetNavCompany,
        targetNavEquipment: state.bob.targetNavEquipment,
        targetNavSite:      state.bob.targetNavSite
    };
};

const mapDispatchToProps = {
    ...AttributeManagementActions,
    ...BobActions,
    ...DashboardActions,
    ...CompanyInfoActions,
    ...CompanyManagementActions,
    ...ConfigurationActions,
    ...CoreActions,
    ...CurrentUserActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BobNavSelectors));
